import React, { useState, useRef, useEffect } from 'react';

import { Button, Icon, Select, colors, useTheme } from '@iq/react-components';

const NotificationFilter = ({ filters, onApply, onReset }) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [localValues, setLocalValues] = useState(() =>
    Object.fromEntries(filters.map((f) => [f.key, []]))
  );
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = (key, value) => {
    setLocalValues((prev) => ({ ...prev, [key]: value || [] }));
  };

  const handleApply = () => {
    onApply(localValues);
    setIsOpen(false);
  };

  const handleReset = () => {
    const empty = Object.fromEntries(filters.map((f) => [f.key, []]));
    setLocalValues(empty);
    onReset();
    setIsOpen(false);
  };

  const activeFilterCount = Object.values(localValues).reduce((count, v) => count + v.length, 0);

  return (
    <div
      className="notification-filter"
      id="role-filter"
      ref={ref}
    >
      <div
        className="notification-filter__trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>
          Filters
          {activeFilterCount > 0 && (
            <span className="notification-filter__badge">{activeFilterCount}</span>
          )}
        </span>
        <Icon
          icon="he-down"
          size="xs"
        />
      </div>

      {isOpen && (
        <div className="notification-filter__panel">
          <div className="notification-filter__header">
            <span className="notification-filter__title">Filters</span>
            <div className="notification-filter__header-actions">
              <Button
                activity="secondary"
                slim
                onClick={handleReset}
              >
                Reset
              </Button>
              <Button
                activity="primary"
                slim
                onClick={handleApply}
              >
                Apply
              </Button>
            </div>
          </div>

          {filters.map((filter) => (
            <div
              key={filter.key}
              className="notification-filter__field"
            >
              <label>{filter.label}</label>
              <Select
                isMulti
                isClearable={false}
                hideSelectedOptions={false}
                options={filter.options}
                value={localValues[filter.key]}
                onChange={(value) => handleChange(filter.key, value)}
                placeholder={`Select ${filter.label.toLowerCase()}...`}
                styles={{
                  option: (base, state) => ({
                    ...base,
                    color: state.isSelected || theme === 'dark' ? colors.Grey0 : base.color,
                  }),
                }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationFilter;
